import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing.css */
  &.landing_level {
    width: 90%;
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    position: relative;
    z-index: 0;
    padding: 15px 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  &.landing_level form {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 5px 0;
    position: relative;
    z-index: 1;
    width: 80%;
  }
  &.landing_level form input {
    padding: 10px 20px;
    max-width: 300px;
    width: 100%;
    font-size: 0.9rem;
    border-radius: 10px 0 0 10px;
    background: rgba(255, 255, 255, 0.1);
    text-align: left;
    position: relative;
    z-index: 2;
  }
  &.landing_level form input:focus {
    box-shadow: 0 0 25px 5px rgba(42, 109, 255, 0.7);
    background: rgba(255, 255, 255, 0.5);
  }
  &.landing_level form button {
    padding: 12px 20px;
    font-size: 0.9rem;
    border-radius: 0 10px 10px 0;
    white-space: nowrap;
    position: relative;
    z-index: 3;
  }
`

const developerCSS = css``

export const JoinYoloSectionCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
